<div class="flex flex-col gap-6">
  <h2 class="text-xl font-bold text-gray-12 m-0 flex items-center gap-2.5">
    <mat-icon class="text-indigo-9">info</mat-icon>
    <span>Critères essentiels</span>
  </h2>

  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-6 gap-x-8 text-sm">
    <!-- Type de bien -->
    <div class="flex items-start gap-3">
      <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-3 text-gray-11">
        <mat-icon class="text-lg!">home</mat-icon>
      </div>
      <div>
        <span class="text-xs text-gray-10 block font-medium">Type de bien</span>
        <span class="font-bold text-gray-12">
          {{ property().definition?.propertyType | etxeEnumDisplay: 'propertyType' }}
          @if (property().keyInfo?.subtype) {
            <span class="text-xs text-gray-11 font-normal"
              >({{
                property().keyInfo?.subtype
                  | etxeEnumDisplay: 'subtype' : property().definition?.propertyType
              }})</span
            >
          }
        </span>
      </div>
    </div>

    <!-- Type de résidence -->
    @if (property().definition?.residenceType) {
      <div class="flex items-start gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-3 text-gray-11">
          <mat-icon class="text-lg!">cottage</mat-icon>
        </div>
        <div>
          <span class="text-xs text-gray-10 block font-medium">Type de résidence</span>
          <span class="font-bold text-gray-12">
            {{ property().definition?.residenceType | etxeEnumDisplay: 'residenceType' }}
          </span>
        </div>
      </div>
    }

    <!-- Surface Habitable -->
    <div class="flex items-start gap-3">
      <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-3 text-gray-11">
        <mat-icon class="text-lg!">straighten</mat-icon>
      </div>
      <div>
        <span class="text-xs text-gray-10 block font-medium">Surface habitable</span>
        <span class="font-bold text-gray-12">
          {{ property().keyInfo?.surface?.habitable || totalInteriorSurface() || '-' }} m²
        </span>
      </div>
    </div>

    <!-- Surface au sol -->
    @if (property().keyInfo?.surface?.ground) {
      <div class="flex items-start gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-3 text-gray-11">
          <mat-icon class="text-lg!">square_foot</mat-icon>
        </div>
        <div>
          <span class="text-xs text-gray-10 block font-medium">Surface au sol</span>
          <span class="font-bold text-gray-12">{{ property().keyInfo?.surface?.ground }} m²</span>
        </div>
      </div>
    }

    <!-- Surface Terrain -->
    @if (property().keyInfo?.surface?.land) {
      <div class="flex items-start gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-3 text-gray-11">
          <mat-icon class="text-lg!">landscape</mat-icon>
        </div>
        <div>
          <span class="text-xs text-gray-10 block font-medium">Surface terrain</span>
          <span class="font-bold text-gray-12">{{ property().keyInfo?.surface?.land }} m²</span>
        </div>
      </div>
    }

    <!-- Nombre de pièces -->
    <div class="flex items-start gap-3">
      <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-3 text-gray-11">
        <mat-icon
          class="text-lg! cursor-help"
          matTooltip="Pièces principales de ≥ 9 m² (chambres, salon, salle à manger, bureau). Exclut cuisines, sanitaires et couloirs."
          matTooltipPosition="above"
        >
          meeting_room
        </mat-icon>
      </div>
      <div>
        <span class="text-xs text-gray-10 block font-medium">Nombre de pièces</span>
        <span class="font-bold text-gray-12">
          @if (mainRoomsCount(); as count) {
            {{ count }} {{ count > 1 ? 'pièces' : 'pièce' }}
          } @else {
            -
          }
        </span>
      </div>
    </div>

    <!-- Nombre de chambres -->
    <div class="flex items-start gap-3">
      <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-3 text-gray-11">
        <mat-icon class="text-lg!">bed</mat-icon>
      </div>
      <div>
        <span class="text-xs text-gray-10 block font-medium">Chambres</span>
        <span class="font-bold text-gray-12">
          {{ property().characteristics?.interior?.bedroom?.length || '-' }} chambres
        </span>
      </div>
    </div>

    <!-- Salles d'eau / bain -->
    <div class="flex items-start gap-3">
      <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-3 text-gray-11">
        <mat-icon class="text-lg!">bathtub</mat-icon>
      </div>
      <div>
        <span class="text-xs text-gray-10 block font-medium">Salles d'eau / bains</span>
        <span class="font-bold text-gray-12">
          {{
            (property().characteristics?.interior?.bathroom?.length || 0) +
              (property().characteristics?.interior?.showerRoom?.length || 0) || '-'
          }}
        </span>
      </div>
    </div>

    <!-- Étage / Ascenseur -->
    @if (property().keyInfo?.accessibility?.apartment?.floor !== undefined) {
      <div class="flex items-start gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-3 text-gray-11">
          <mat-icon class="text-lg!">stairs</mat-icon>
        </div>
        <div>
          <span class="text-xs text-gray-10 block font-medium">Étage</span>
          <span class="font-bold text-gray-12">
            {{ property().keyInfo?.accessibility?.apartment?.floor }}e étage
            @if (
              property().keyInfo?.accessibility?.apartment?.numberOfFloors ||
              property().keyInfo?.accessibility?.buildingNumberOfFloors
            ) {
              /
              {{
                property().keyInfo?.accessibility?.apartment?.numberOfFloors ||
                  property().keyInfo?.accessibility?.buildingNumberOfFloors
              }}
            }
            @if (
              property().keyInfo?.accessibility?.buildingHasElevator ||
              property().keyInfo?.accessibility?.hasElevator
            ) {
              <span class="text-xs text-jade-11 font-medium">(avec ascenseur)</span>
            }
          </span>
        </div>
      </div>
    }

    <!-- PMR -->
    @if (property().keyInfo?.accessibility?.pmrCompliance) {
      <div class="flex items-start gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-jade-a3 text-jade-11">
          <mat-icon class="text-lg!">accessible</mat-icon>
        </div>
        <div>
          <span class="text-xs text-gray-10 block font-medium">Accessibilité</span>
          <span class="font-bold text-jade-11">Normes PMR / Accès mobilité réduite</span>
        </div>
      </div>
    }

    <!-- Copropriété -->
    @if (property().keyInfo?.coOwnership?.isInCoOwnership) {
      <div class="flex items-start gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-3 text-gray-11">
          <mat-icon class="text-lg!">apartment</mat-icon>
        </div>
        <div>
          <span class="text-xs text-gray-10 block font-medium">Copropriété</span>
          <span class="font-bold text-gray-12">
            Bien en copropriété
            @if (property().keyInfo?.coOwnership?.lotNumber) {
              <span class="text-xs text-gray-11 font-normal"
                >(Lot n° {{ property().keyInfo?.coOwnership?.lotNumber }})</span
              >
            }
          </span>
        </div>
      </div>
    }

    <!-- Disponibilité & Urgence de vente -->
    @if (property().keyInfo?.availability) {
      <div class="flex items-start gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-3 text-gray-11">
          <mat-icon class="text-lg!">event_available</mat-icon>
        </div>
        <div>
          <span class="text-xs text-gray-10 block font-medium">Disponibilité</span>
          <span class="font-bold text-gray-12">
            {{ property().keyInfo?.availability?.isOccupied ? 'Occupé' : 'Libre' }}
            @if (property().keyInfo?.availability?.saleUrgency) {
              <span class="text-xs text-gray-11 font-normal block">
                Vente :
                {{ property().keyInfo?.availability?.saleUrgency | etxeEnumDisplay: 'saleUrgency' }}
              </span>
            }
          </span>
        </div>
      </div>
    }

    <!-- Statut de commercialisation -->
    @if (
      property().keyInfo?.availability?.isAlreadyOnSale !== undefined &&
      property().keyInfo?.availability?.isAlreadyOnSale !== null
    ) {
      <div class="flex items-start gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-3 text-gray-11">
          <mat-icon class="text-lg!">storefront</mat-icon>
        </div>
        <div>
          <span class="text-xs text-gray-10 block font-medium">Déjà en vente</span>
          <span class="font-bold text-gray-12">
            {{ property().keyInfo?.availability?.isAlreadyOnSale ? 'Oui' : 'Non' }}
            @if (
              property().keyInfo?.availability?.isAlreadyOnSale &&
              property().keyInfo?.availability?.currentMarketingMode
            ) {
              <span class="text-xs text-gray-11 font-normal block">
                {{
                  property().keyInfo?.availability?.currentMarketingMode
                    | etxeEnumDisplay: 'currentMarketingMode'
                }}
                @if (property().keyInfo?.availability?.exclusiveMandateEndDate) {
                  <span
                    >(fin le
                    {{
                      property().keyInfo?.availability?.exclusiveMandateEndDate | luxonDate: 'dd/MM/yyyy'
                    }})</span
                  >
                }
              </span>
            }
          </span>
        </div>
      </div>
    }
  </div>
</div>
